import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section-two";
import ProductSingle from "../components/product";
import listProduct from '../components/product.json'
const Seacher = () =>{
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header whihOne="seacher" />
               <HeaderSection 
               title="Hello How Can We Help You " 
               smallTitle="By Using " 
               usmallTitle="Search bar"
               />
               <section id="section_shop">
                <div id="order_id_div">
                <input type="text"  id="order_id_div_input" placeholder="Write...." className="ssclkd" autoFocus/>
                </div>
                <div id="grid_4_cart">
                        {
                            listProduct.map((v,k)=>{
                                return <ProductSingle key={k} data={v}  />
                            })
                        }
                    </div>
               </section>
            <Footer />
        </div>
    )
}
export default Seacher;
